import { DocumentDndSliceApi } from "@shared";

import { DocumentGroup, documentsApi } from "@/api";
import { invalidateDocumentZoneQueries } from "@/common/components/layout/components/dropzone/dnd/DropZoneDnd.utils";
import { SlotAssetDocumentSection } from "@/common/components/layout/components/dropzone/dnd/SlotAssetDocumentSection";

/**
 * The internal app's documentDnd slice: injects the full asset upload-area section (drop target,
 * rows with the DropZone file actions, pending moves) and the move-persist primitives into the
 * shared client-file views. The portal provides no counterpart — its document blocks fall back to
 * plain upload areas.
 */
export const documentDndSlice: DocumentDndSliceApi = {
  AssetDocumentSection: SlotAssetDocumentSection,
  moveDocument: ({ clientId, target, documentId }) =>
    documentsApi.moveDocument({
      clientId,
      moveDocumentRequest: { target: target as DocumentGroup, fileId: documentId },
    }),
  invalidateDocumentZoneQueries,
};
